import React from "react";
import styles from "./IR330C.module.scss";

const IR330CTaxCode = (props) => {
 const { setTaxCode, taxCode } = props;
 const onTextChange = e => {
  setTaxCode({ "name":e.target.name, "value":e.target.value});
}
  return (
    <div className={styles.irdInnerDetails}>
      <div className="row">
        <div className="col-sm-12 col-md-8 col-lg-6">
          <div className={styles.irdInnerDetailsTitle + " mb-2"}>
            2 <span className="pl-3">Your tax code</span>
          </div>{" "}
        </div>
      </div>
      <div className={styles.rowMargin + " row"}>
        <div className="col-sm-12 col-md-9 col-lg-9">
          <div className="page-title-2">
            <ul>
              <li>You must complete a separate Tax code declaration for each source of income.</li>
              <li>Choose only 1 tax code per source of income.</li>
            </ul>
          </div>
          <p className="page-title-2">
            Use the flowchart on the next page to help work out the right tax code to use.
          </p>
        </div>
        <div className="col-sm-6 col-md-2 col-lg-2 text-right">
          <div className="page-title-2">Enter your<br/> tax code here</div>
        </div>
        <div className="col-sm-6 col-md-1 col-lg-1 text-center">
          <div className="taxcode-inputbox">
            <div className="inputbox">
              <input maxLength="5" type="text" id="taxCode" name="taxCode" value={taxCode} onChange={onTextChange} required={true} />
            </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default IR330CTaxCode;
